import { destroySession } from '../actions/session'

export default function (user) {
  const scriptTag = document.querySelector('script[src*=index-]')
  if (scriptTag) {
    const currentSrc = scriptTag.getAttribute('src')
    const headers = new Headers()
    headers.append('pragma', 'no-cache')
    headers.append('cache-control', 'no-cache')
    fetch('/', {
      method: 'get',
      headers
    })
      .then(response => response.text())
      .then(text => {
        if (user) {
          fetch('/api/users/?q='+user.email+'&exact=false', {
            methods:'get'
          })
          .then(response => {return response.json()})
          .then(data => {
            if (data.data && data.data[0] && data.data[0].attributes && data.data[0].attributes.disabled) {
              destroySession()
            }
          })
          .catch(() => {
            // Silently handle user check errors to avoid disrupting session
          })
        }
        const hasLatest = text.indexOf(currentSrc) > -1
        if (hasLatest) {
          return
        }
        const lastScriptTryAt = localStorage.getItem('lastScriptTryAt')
        if (lastScriptTryAt === currentSrc) {
          return // do not retry; avoid infinite loop
        }
        // Only reload if user is not actively using the app AND no session active
        const lastActivity = localStorage.getItem('lastUserActivity')
        const now = Date.now()
        const hasSession = localStorage.sessionId
        
        // Don't reload if:
        // 1. User was active in the last 10 minutes
        // 2. User has an active session (they're logged in)
        if ((lastActivity && (now - parseInt(lastActivity)) < 600000) || hasSession) {
          console.log('Delaying app update - user is active or has session')
          return
        }
        
        console.log('App version outdated, reloading...')
        localStorage.setItem('lastScriptTryAt', currentSrc)
        window.location.reload()
      })
      .catch(() => {
        // Silently handle fetch errors to avoid disrupting user experience
      })
  }
}
